import { ACTION } from '../app/app_actions';

const initialState = {
  isShowSideMenu: true,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case ACTION.SHOW:
      return {
        ...state,
        isShowSideMenu: true,
      };
    case ACTION.HIDE:
      return {
        ...state,
        isShowSideMenu: false,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/redux/app/app_reducer.js